
import moment from 'moment'

export const dateFormat = function (str) {
  return str ? moment(str).format('YYYY-MM-DD') : ''
}

export const weekFormat = function (str) {
  return moment(str).format('dddd')
}

export const amountFormat = function (amount) {
  return (amount + '')
    .split('')
    .reverse()
    .join('')
    .replace(/(\d{3})(?=\d)/g, '$1,')
    .split('')
    .reverse()
    .join('')
}

export const getOrderID = function (order) {
  var suffix = '' + order.ID
  while (suffix.length < 7) suffix = '0' + suffix
  return order.CreatedAt.substring(2, 10).replace(/-/g, '') + suffix
}
